// import axios from '../plugins/axios'
const state = {
  c_task_id: "",
  add_calendar_task_modal: false,
  p_id: null,
  type_module: "",
  unique_id: "",
  calendar_selected_date: null,
  vendor_list: [],
  user_list: [],
  task_list: [],
  project_list: [],
};
const getters = {
  getDataByKey: (state) => (key) => {
    return state[key];
  },
};
const actions = {};
const mutations = {
  setAddTaskData(state, data) {
    state[data.key] = data.value;
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
